/* TODO: 添加美东host配置 */
const host = {
    didi: {
        online: 'https://api.didi.cn',
        offline: 'http://v-test.intra.xiaojukeji.com',
        preline: 'https://vstage-pre.intra.xiaojukeji.com',
        simline: 'https://vstage-sim.intra.xiaojukeji.com' // qasim环境
    },
    kf: {
        online: 'https://api.huaxz.cn',
        offline: 'http://v-test.intra.xiaojukeji.com',
        preline: 'https://vstage-pre.intra.xiaojukeji.com',
        simline: 'https://vstage-sim.intra.xiaojukeji.com' // qasim环境
    }
};
export const xposParamsMap = {
    resname: 'rn',
    element_name: 'en',
    xspm: 'xp',
    index: 'idx',
    component_id: 'cid',
    prod_key: 'pk'
};
/**
 * 根据传入的品牌、环境标识，返回正确的host
 */
export function getHostByEnv(hostBranch = 'didi', env = 'online') {
    return host[hostBranch][env];
}
/**
 * 跨端获取产品初始化配置
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function commonInitProduct(option, env, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/chapter/product/init`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端pageConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param isDebug 是否是页面预览服务
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function getCommonPageConfig(option, env, nineChapterWebxParams, sessionData, hostBranch, isDebug, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/page/config${isDebug ? '?debug=1' : ''}`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端pageBatchConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param isDebug 是否是页面预览服务
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function getCommonPageBatchConfig(option, env, nineChapterWebxParams, sessionData, hostBranch, isDebug, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/chapter/page/batch/config${isDebug ? '?debug=1' : ''}`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端shareConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function getCommonShareConfig(option, env, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/chapter/share/config`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端shareBatchConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function getCommonShareBatchConfig(option, env, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/chapter/share/batch/config`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端coverConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param nineChapterWebxParams 九章webx参数(sdk自动获取)
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function getCommonCoverConfig(option, env, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    }, { dchn: option.dchn, xenv: option.xenv });
    return requestFn(`${host}/webx/chapter/cover/config`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true
        // emulateJSON: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端xaidConfig公共方法
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function getCommonXaidConfig(option, env, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/xaid/config`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true,
        // emulateJSON: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
/**
 * 跨端webx更新用户信息请求
 * @param option 用户请求参数
 * @param env 线上、线下、预览机域名切换
 * @param sessionData webx请求会话信息(自动获取)
 * @param hostBranch 请求对应的品牌(sdk自动获取)
 * @param clusterId: webx集群id(自动根据xpsid获取)
 * @param requestFn 请求fn
 * @returns
 */
export async function commonUpdateWebxUserInfo(option, env, nineChapterWebxParams, sessionData, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    const data = Object.assign({}, sessionData, nineChapterWebxParams, option, {
        openid: option['openid'] || nineChapterWebxParams['openid'],
        token: option['token'] || nineChapterWebxParams['token'],
        uid: option['uid'] || nineChapterWebxParams['uid'],
        xenv: option['xenv'] || nineChapterWebxParams['xenv'],
        lat: option['lat'] || nineChapterWebxParams['lat'],
        lng: option['lng'] || nineChapterWebxParams['lng'],
        cityid: option['cityid'] || nineChapterWebxParams['cityid']
    });
    return requestFn(`${host}/webx/chapter/user/update`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true,
        // emulateJSON: true
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 获取拉端策略
export async function getCommonLaunchAppConfig(data, env, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    return requestFn(`${host}/webx/chapter/invoke/config`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true,
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 获取拉端状态
export async function getCommonLaunchAppStatus(data, env, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    return requestFn(`${host}/webx/chapter/invoke/status`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true,
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 上报拉端事件
export async function trackCommonLaunchAppEvent(data, env, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    return requestFn(`${host}/webx/chapter/invoke/push`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true,
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
// 上报拉端功能内部埋点
export async function upCommonLaunchAppEvent(data, env, hostBranch, clusterId, requestFn) {
    const host = getHostByEnv(hostBranch, env);
    return requestFn(`${host}/webx/chapter/invoke/tracking/user`, data, {
        header: {
            'X-Cluster-Id': clusterId
        },
        isWebx: true,
        needSign: true,
    }).then(res => +res.errno === 0 && res.data ? Promise.resolve(res.data) : Promise.reject(res));
}
